module.exports = __webpack_public_path__ + "static/media/mouse.7ec71dc5.png";